import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useLayoutEffect } from "react";
const OverlayContainerContext = createContext(void 0);
function OverlayProvider({
  children,
  containerId
}) {
  const [container, setContainer] = useState(void 0);
  useLayoutEffect(() => {
    setContainer(document.getElementById(containerId) || void 0);
  }, [containerId]);
  return /* @__PURE__ */ jsx(OverlayContainerContext.Provider, { value: container, children });
}
function useOverlayContainer() {
  return useContext(OverlayContainerContext);
}
export {
  OverlayProvider,
  useOverlayContainer
};
//# sourceMappingURL=overlay-context.js.map
